import { ChartBarIcon, LightBulbIcon } from '@heroicons/react/outline';
import { GAME_TITLE } from '../../constants/strings';
import ImgCactus from '../../assets/cactus.png';
import { Sponsors } from '../navbar/Sponsors';

export const Navbar = ({ setIsInfoModalOpen, setIsStatsModalOpen }) => {
  return (
    <div className="navbar">
      <div className="navbar-banner px-5 py-2 bg-yellow-400 relative flex justify-center items-center w-full">
        <p className="text-sm italic">
          Mas juegos:{' '}
          <a
            className="underline font-bold"
            href="https://www.zeusagencia.com/juegos"
            target="_BLANK"
            rel="noopener noreferrer"
          >
            Zeus Agencia
          </a>
        </p>
      </div>

      {/* Inserta el componente Sponsors aquí */}
      <Sponsors />
      <hr />

      <div className="navbar-content px-5">
        <LightBulbIcon
          className="h-6 w-6 mr-2 cursor-pointer text-white"
          onClick={() => setIsInfoModalOpen(true)}
        />
        <div className="flex">
          <p className="text-xl font-bold text-white">{GAME_TITLE}</p>
          <img className="h-6 w-6 ml-1 cursor-pointer text-white" src={ImgCactus} alt="" />
        </div>
        <div className="right-icons">
          <ChartBarIcon
            className="h-6 w-6 mr-3 cursor-pointer text-white"
            onClick={() => setIsStatsModalOpen(true)}
          />
        </div>
      </div>
      {/* aqui va el hr si no quiero los sponsors */}
    </div>
  );
};